module.exports = __webpack_public_path__ + "media/images/ohap_lms_integration_off-fc217856378f259c7bdf3893ed68fa2b.png";